import { useSortable } from "@dnd-kit/sortable"
import { Cell, flexRender } from "@tanstack/react-table"
import { CSSProperties } from "react"
import { CSS } from "@dnd-kit/utilities"

const DragAlongCell = ({ cell }: { cell: Cell<unknown, unknown> }) => {
  const { isDragging, setNodeRef, transform } = useSortable({
    id: `${cell.row.id}-${cell.column.id}`,
  })

  const style: CSSProperties = {
    opacity: isDragging ? 0.8 : 1,
    transform: transform ? CSS.Transform.toString(transform) : undefined,
    transition: "transform 0.2s ease-in-out",
    width: cell.column.getSize(),
    zIndex: isDragging ? 1 : 0,
  }

  return (
    <td style={style} ref={setNodeRef}>
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  )
}

export default DragAlongCell
